/**
 * 권한 그룹 서비스
 */

import apiClient from './api';
import {
  RoleGroup,
  RoleGroupFilter,
  RoleGroupListResponse,
} from '../types/admin';

export const roleGroupService = {
  /**
   * 권한 그룹 목록 조회
   */
  async getRoleGroups(filter: RoleGroupFilter = {}): Promise<RoleGroupListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: RoleGroupListResponse }>(`/admin/role-groups?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      role_groups: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 권한 그룹 상세 조회
   */
  async getRoleGroup(id: number): Promise<RoleGroup> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { role_group: RoleGroup } }>(`/admin/role-groups/${id}`);
    // return response.data.data.role_group;

    throw new Error('Not implemented');
  },

  /**
   * 권한 그룹 등록
   */
  async createRoleGroup(data: Partial<RoleGroup>): Promise<RoleGroup> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { role_group: RoleGroup } }>('/admin/role-groups', data);
    // return response.data.data.role_group;

    throw new Error('Not implemented');
  },

  /**
   * 권한 그룹 수정
   */
  async updateRoleGroup(id: number, data: Partial<RoleGroup>): Promise<RoleGroup> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { role_group: RoleGroup } }>(`/admin/role-groups/${id}`, data);
    // return response.data.data.role_group;

    throw new Error('Not implemented');
  },

  /**
   * 권한 그룹 삭제
   */
  async deleteRoleGroup(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/role-groups/${id}`);

    throw new Error('Not implemented');
  },
};

